import Vue from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery'
// 导入全局样式
import store from './store'
import './plugins/vant.js'
import { DatePicker } from 'element-ui';

Vue.use(DatePicker)


import axios from 'axios'
// axios.defaults.baseURL = 'http://127.0.0.1:8001/api'
axios.defaults.baseURL = 'https://train.yunlankeji.com/api'

// 在request 拦截器中, 展示进度条 NProgress.start()
// 请求在到达服务器之前，先会调用use中的这个回调函数来添加请求头信息
axios.interceptors.request.use(config => {
    //NProgress.start()
    // console.log(config)
    // 为请求头对象，添加token验证的Authorization字段
    config.headers.Authorization = window.sessionStorage.getItem('token')
    // 在最后必须 return config
    return config
  })
  
  // 挂在到Vue实例，后面可通过this调用
  Vue.prototype.$http = axios
  
  Vue.config.productionTip = false
  
  Vue.filter('dataFormat', function (originVal) {
    const dt = new Date(originVal)
  
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
  
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    // yyyy-mm-dd hh:mm:ss
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  })

//路由跳转回到顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  })
/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')